/**
 * Where the Sites surfaces send the user (web). Like the native twin, and
 * Edit also docks the canvas panel on the site's page beside its thread.
 */
import { router } from 'expo-router';
import { armArtifactContext, bindThreadToSite, startSiteCompose } from '@/lib/site-compose';
import { openArtifactPanel } from '../artifacts/artifact-panel-store';
import { hidePublishSheet } from './publish-sheet-store';
import { siteSettingsHref } from './sites-list-model';

const CHAT = '/chat';

function fresh() {
  return Date.now().toString(36);
}

export function createSiteInChat() {
  startSiteCompose();
  router.push({ pathname: CHAT, params: { fresh: fresh() } } as never);
}

export function editSiteInChat(site: { id: string; artifactId: string; threadId: string | null }) {
  if (site.threadId) {
    bindThreadToSite(site.threadId, { siteId: site.id, artifactId: site.artifactId });
    router.push(`${CHAT}/${encodeURIComponent(site.threadId)}` as never);
  } else {
    armArtifactContext({ artifactId: site.artifactId, site: true });
    router.push({ pathname: CHAT, params: { fresh: fresh() } } as never);
  }
  openArtifactPanel(site.artifactId);
}

export function fixPageWithTabbio(artifactId: string, prompt: string) {
  hidePublishSheet();
  armArtifactContext({ artifactId });
  const id = fresh();
  router.push({ pathname: CHAT, params: { fresh: id, prompt, promptId: `site-fix-${artifactId}-${id}` } } as never);
}

export function openSitesList() {
  hidePublishSheet();
  router.push('/sites' as never);
}

export function openSiteSettings(siteId: string, tab: 'settings' | 'analytics' = 'settings') {
  router.push(siteSettingsHref(siteId, tab) as never);
}
